var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47396 6.82353C7.47396 6.5528 7.70948 6.33333 8 6.33333C8.29052 6.33333 8.52604 6.5528 8.52604 6.82353V8.78431C8.52604 9.05504 8.29052 9.27451 8 9.27451C7.70948 9.27451 7.47396 9.05504 7.47396 8.78431V6.82353Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.86274C7.70948 9.86274 7.47396 10.0822 7.47396 10.3529C7.47396 10.6237 7.70948 10.8431 8 10.8431C8.29052 10.8431 8.52604 10.6237 8.52604 10.3529C8.52604 10.0822 8.29052 9.86274 8 9.86274Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7653 10.5962L13.7682 10.6009C14.4348 11.6837 13.58 13 12.2719 13H3.72807C2.41997 13 1.56522 11.6838 2.23184 10.6009L2.23474 10.5962L6.51054 3.7972C6.66259 3.55357 6.88045 3.35267 7.14088 3.21336C7.40278 3.07327 7.69912 3 8 3C8.30088 3 8.59723 3.07327 8.85912 3.21336C9.11958 3.35268 9.33745 3.55361 9.48949 3.79725L13.7653 10.5962ZM8.39884 4.38982L12.6731 11.1864C12.8483 11.471 12.627 11.8235 12.2719 11.8235H3.72807C3.37303 11.8235 3.15171 11.471 3.32692 11.1864L7.60116 4.38982C7.64132 4.32501 7.69936 4.27114 7.7694 4.23367C7.83945 4.19621 7.919 4.17647 8 4.17647C8.081 4.17647 8.16055 4.19621 8.2306 4.23367C8.30064 4.27114 8.35868 4.32501 8.39884 4.38982Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputError);
export default __webpack_public_path__ + "static/media/inputError.903a27e7022ea2f18d666a8b72c277c6.svg";
export { ForwardRef as ReactComponent };